import React, {useEffect } from 'react';


const Whatwedo = ()=>{


    const color="#abcfe6";


   useEffect(() => {
    document.querySelector('#outer-main').style.display="none"
    document.body.style.backgroundColor = color ;
    document.querySelector(".navi" + 0).style.display="block";
    document.querySelector(".navi" + 0).style.background="routerButtonColor[e.currentTarget.dataset.index]";
   }, []);



return(


<>

       
<section id="subViews">

<div><img src="/assets/images/front-what-we-do-link.png" alt="img" /></div>
<div className="children">
    <div className="sub-headline">Design is the matter of choise</div>
    <div className="sub-text-what">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</div>
    <div id="bottom"><div>whatWeDo</div></div>
    </div>
</section>
</>

)

}

export default Whatwedo;